import React from 'react';
import ContactSec from '../components/Contact';

const Contact = () => {
  return (



        <ContactSec />



      
  );
};

export default Contact;
